const form = $('#form_contacts');
const inputs = form.find('[data-model-input]');
const textarea = form.find('[data-textarea]');
const textareaEl = textarea.find('textarea');
const modelSelect = form.find('[name=model]');
const dateInput = form.find('#purchase-date');

const toggleFieldVisibility = (field, isVisible) => {
  const $field = $(field);
  const $input = $field.find('input');
  const $errorLabel = $field.find('label.error');

  if (isVisible) {
    $field.removeClass('form-group--hidden');
    if ($field.data('model-input') === 'required') {
      $input.prop('required', true);
      $input.on('input', handleChange);
    }
  } else {
    $input.prop('required', false).removeClass('error');
    $field.addClass('form-group--hidden');
    $errorLabel.remove();
    if ($field.data('model-input') === 'required') {
      $input.off('input', handleChange);
    }
  }
};

const handleModelChange = (event) => {
  const value = $(event.target).val();
  const isHidden = !value || value === '-1';

  inputs.each((_, field) => {
    toggleFieldVisibility(field, !isHidden);
  });

  if (value === '-1') {
    textarea.removeClass('form-group--hidden');
    textareaEl.prop('required', true);
  } else {
    textarea.addClass('form-group--hidden');
    textareaEl.prop('required', false);
  }
};

const handleChange = () => {
  const isCompleted = isInputsCompleted();
  textarea.toggleClass('form-group--hidden', !isCompleted);
  textareaEl.prop('required', isCompleted);
};

const isInputsCompleted = () => {
  return inputs.filter((_, field) => $(field).data('model-input') === 'required')
               .toArray()
               .every(field => $(field).find('input').val());
};

if (modelSelect.length) {
  modelSelect.on('change', handleModelChange);
}

if (dateInput.length) {
  dateInput.on('change', function() {
    if (this.value) {
      $(this).addClass('has-changed');
    } else {
      $(this).removeClass('has-changed');
    }
  });
}